import { useCallback, useState } from 'react';
import { Simulado } from '../../sdk/@types';
import SimuladoService from '../../sdk/services/SimuladoService';
import QuestaoSimuladoService from '../../sdk/services/QuestaoSimuladoService';
import { notification } from "antd";

export default function useSimuladoQuestao() {
  const [questaoSimulado, setQuestaoSimulado] = useState<Simulado.QuestaoSimulado>();

  const [questoesSimulado, setQuestoesSimulado] = useState<Simulado.QuestaoSimulado[]>([]);

  const newQuestaoSimulado = useCallback(() => {
    setQuestaoSimulado({});
  }, []);

  const insertQuestaoSimulado = useCallback(async (data: Simulado.Simulado) => {
    setQuestaoSimulado(await QuestaoSimuladoService.inserirNovaQuestaoSimulado(data));
  }, []);

  const insertMany = useCallback(async (data: Simulado.Simulado) => {
    setQuestoesSimulado(await QuestaoSimuladoService.inserirMuitas(data));
  }, []);

  const fetchQuestaoSimulado = useCallback((id: string) => {
    QuestaoSimuladoService.getQuestaoSimulado(id);
  }, []);

  const fetchQuestoesSimulado = useCallback(async (simuladoId : string) => {
    if (!(simuladoId && simuladoId.length > 0))
      return ;
    
    setQuestoesSimulado(await QuestaoSimuladoService.getQuestoesSimulado(simuladoId));
  }, []);

  const deleteQuestaoSimulado = useCallback(async (id: string) => {
    await QuestaoSimuladoService.delete(id);

    notification.info({
      message: "Sucesso",
      description: "Questão removida com sucesso.",
    });

  }, [])

  return {
    questaoSimulado,
    questoesSimulado,
    newQuestaoSimulado,
    insertQuestaoSimulado,
    insertMany,
    setQuestaoSimulado,
    setQuestoesSimulado,
    fetchQuestaoSimulado,
    fetchQuestoesSimulado,
    deleteQuestaoSimulado,
  };
}
